import { Heading, VStack } from "@navikt/ds-react";
import { DashboardGrid } from "~/components/dashboard";
import { useChoiceFilter } from "~/hooks/useChoiceFilter";
import { useSearchParams } from "~/hooks/useSearchParams";
import { useStats } from "~/hooks/useStats";
import { ChoiceFieldCard, RatingFieldCard, TextFieldCard } from "./FieldCards";
import { FieldStatsPeriodComparison } from "./PeriodComparison";
import { Skeleton } from "./Skeleton";

export function FieldStatsSection() {
  const { data: stats, isPending, isPlaceholderData } = useStats();
  const { params } = useSearchParams();
  const {
    activeFilters: activeChoiceFilters,
    toggleChoice,
    removeChoice,
  } = useChoiceFilter();
  const hasSurveyFilter = !!params.surveyId;

  if ((isPending || isPlaceholderData) && hasSurveyFilter) {
    return <Skeleton />;
  }

  if (!stats?.fieldStats?.length) {
    return null;
  }

  if (
    hasSurveyFilter &&
    (stats.surveyType === "rating" || stats.surveyType === "custom")
  ) {
    return <FieldStatsPeriodComparison stats={stats} />;
  }

  return (
    <VStack
      data-testid="field-stats-section"
      gap="space-16"
      marginBlock="space-24 space-16"
    >
      <Heading level="2" size="small">
        Statistikk per felt
      </Heading>

      <DashboardGrid
        minColumnWidth="280px"
        gap={{ xs: "space-16", md: "space-24" }}
      >
        {stats.fieldStats.map((field) => {
          switch (field.fieldType) {
            case "RATING":
              return (
                <RatingFieldCard
                  key={field.fieldId}
                  field={field}
                  totalCount={stats.totalCount}
                />
              );
            case "TEXT":
              return (
                <TextFieldCard
                  key={field.fieldId}
                  field={field}
                  totalCount={stats.totalCount}
                />
              );
            case "SINGLE_CHOICE":
            case "MULTI_CHOICE":
              return (
                <ChoiceFieldCard
                  key={field.fieldId}
                  field={field}
                  totalCount={stats.totalCount}
                  activeChoiceFilters={activeChoiceFilters}
                  onChoiceSelect={(optionId) =>
                    toggleChoice(field.fieldId, optionId)
                  }
                  onChoiceClear={() => removeChoice(field.fieldId)}
                />
              );
            default:
              return null;
          }
        })}
      </DashboardGrid>
    </VStack>
  );
}
